import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { LoginHintExpirationTypeTypes } from "@enums/login-hint-expiration-type-types";
import { isNullOrUndefined } from "@utils/object-util";
import { isStringValidNumberRegex } from "@utils/string-util";
import React from "react";

export const getLoginHintExpirationValueValidationErrors = (
    loginHintExpirationType: string,
    loginHintExpirationValue: string
): {
    count: number;
    loginHintExpirationValueError: React.ReactNode; 
} => {
    let loginHintExpirationValueError = null;
    let count = 0;

    if (!isNullOrUndefined(loginHintExpirationValue) && loginHintExpirationValue !== "") {
        if (loginHintExpirationType === LoginHintExpirationTypeTypes.DURATION) {
            const isValid = isStringValidNumberRegex(loginHintExpirationValue);
            if (!isValid) {
                loginHintExpirationValueError = <ErrorAlert>
                    <span>{"Please enter a valid duration in minutes"} </span>
                </ErrorAlert>;
                count++;
            }
        }
    }

    return {
        count,
        loginHintExpirationValueError
    }
}